export default "__VITE_ASSET__XeFn2xmk__"